export default "__VITE_ASSET__VbSv1lrN__"